module.exports = __webpack_public_path__ + "static/media/salute_benessere.a2e31d9d.jpg";